import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const toggleDefaultVariants = {}
const toggleCompoundVariants = [
  {
    "selected": true,
    "disabled": true,
    "css": {
      "track": {
        "background": "interactive.disabled"
      }
    }
  }
]

const toggleSlotNames = [
  [
    "root",
    "Toggle__root"
  ],
  [
    "track",
    "Toggle__track"
  ],
  [
    "thumb",
    "Toggle__thumb"
  ]
]
const toggleSlotFns = /* @__PURE__ */ toggleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, toggleDefaultVariants, getSlotCompoundVariant(toggleCompoundVariants, slotName))])

const toggleFn = memo((props = {}) => {
  return Object.fromEntries(toggleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const toggleVariantKeys = [
  "focusVisible",
  "selected",
  "disabled"
]
const getVariantProps = (variants) => ({ ...toggleDefaultVariants, ...compact(variants) })

export const toggle = /* @__PURE__ */ Object.assign(toggleFn, {
  __recipe__: false,
  __name__: 'toggle',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: toggleVariantKeys,
  variantMap: {
  "focusVisible": [
    "true"
  ],
  "selected": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, toggleVariantKeys)
  },
  getVariantProps
})